import { call, put, takeEvery } from "redux-saga/effects";
import FileSaver from "file-saver";
// Ecommerce Redux States
import {
  ALLEXPORT,
  ASSOCIATE,
  DISSASOCIATE,
  DOWNLOAD,
  GET,
  GET_ALL,
  GET_ALL_ASSIGNED,
  GET_ALL_ASSIGNED_FOR_DOCUMENTID,
  GET_ALL_NOTASSIGNED,
  GET_ALL_PAGETYPE,
  GET_ALL_PROCCESS,
  GET_ALL_REJECTION_REASON,
  GET_ALL_STATES,
  GET_BY_DOCUMENT_NUMBER,
  GET_XML_TRANSSMITIONS,
  OPEN,
  REJECT,
  SAVE,
  SAVEAPROVAL,
  SAVEASSIGNED,
  SAVEATTACHS,
  SAVEREACTIVE,
  SAVE_PREVALORIZATION,
  TYPES,
  UPDATE,
  UPDATE_TYPES,
} from "./actionTypes";
import {
  getFail,
  getSuccess,
  getAllFail,
  getAllSuccess,
  saveFail,
  saveSuccess,
  updateFail,
  disassociateSuccess,
  disassociateFail,
  getAllXmlSuccess,
  getAllXmlFail,
  getAllTypes,
  getAllTypesFail,
  getAllTypesSuccess,
  updateTypeSuccess,
  updateTypeFail,
  getByDocumentSuccess,
  getByDocumentFail,
  associateFail,
  associateSuccess,
  openSuccess,
  openFail,
  rejectSuccess,
  rejectFail,
  getAllStatesSuccess,
  getAllStatesFail,
  getAllAssignedSuccess,
  getAllAssignedFail,
  getAllNotAssignedSuccess,
  getAllNotAssignedFail,
  saveAssignedSuccess,
  saveAssignedFail,
  getAllPageTypeSuccess,
  getAllPageTypeFail,
  getAllProccessSuccess,
  getAllProccessFail,
  saveAttachsSuccess,
  saveAttachsFail,
  getAllAllAssignedForDocumentIdSuccess,
  getAllAssignedForDocumentIdFail,
  getAllAssignedForDocumentIds,
  getAllRejectionReasonSuccess,
  getAllRejectionReasonFail,
} from "./actions";

import {
  get,
  getAll,
  post,
  update,
  disassociateService,
  getAllTransmissions,
  getTypes,
  putTypes,
  getByDocumentNumber,
  associateService,
  openService,
  rejectService,
  exportDocument,
  savePrevalorizationService,
  getAllStatus,
  getAllAssigned,
  getAllNotAssigned,
  postSaveAssigned,
  getAllPageType,
  postProccessService,
  postSaveAttachs,
  getAllAssignedForDocumentId,
  postSaveApproval,
  postSaveReactive,
  exportAllDocument,
  getRejectionReasonAll,
} from "./Service";
import toast from "react-hot-toast";
function* fetchAll({ payload }) {
  try {
    const response = yield call(getAll, payload);
    yield put(getAllSuccess(response));
  } catch (error) {
    yield put(getAllFail(error));
  }
}

function* fetchAllStates({ payload }) {
  try {
    const response = yield call(getAllStatus, payload);
    yield put(getAllStatesSuccess(response));
  } catch (error) {
    yield put(getAllStatesFail(error));
  }
}

function* getByDocument({ payload }) {
  try {
    const response = yield call(getByDocumentNumber, payload);
    yield put(getByDocumentSuccess(response));
  } catch (error) {
    yield put(getByDocumentFail(error));
  }
}

function* xlsTransmissions({ payload }) {
  try {
    const response = yield call(getAllTransmissions, payload);
    yield put(getAllXmlSuccess(response));
  } catch (error) {
    yield put(getAllXmlFail(error));
  }
}

function* getParametrizationList({ payload }) {
  try {
    const response = yield call(getTypes, payload);
    yield put(getAllTypesSuccess(response));
  } catch (error) {
    yield put(getAllTypesFail(error));
  }
}
function* updateTypes({ payload }) {
  try {
    const response = yield call(putTypes, payload);
    yield put(updateTypeSuccess(response));
  } catch (error) {
    yield put(updateTypeFail(error));
  }
}

function* disassociate({ payload }) {
 
  const {objReactive,setShowReactivarViaje} = payload ?? {};
 
  try {
    const response = yield call(disassociateService, objReactive);
    if (response) {
      toast.success("Documento desasociado correctamente");
      setShowReactivarViaje(false);
    }
   
    else
      toast.error("No se puede desasociar el documento, verifique el estado");
    yield put(disassociateSuccess(response));
  } catch (error) {
    yield put(disassociateFail(error));
  }
}
function* associate({ payload }) {
  try {
    const response = yield call(associateService, payload);
    if (response) toast.success("Documento associado correctamente");
    else toast.error("No se puede associar el documento, verifique el estado");
    yield put(associateSuccess(response));
  } catch (error) {
    yield put(associateFail(error));
  }
}

function* open({ payload }) {
  try {
    const response = yield call(openService, payload);
    if (response) toast.success("Documento abierto correctamente");
    else toast.error("No se puede abrir el documento, verifique el estado");
    yield put(openSuccess(response));
  } catch (error) {
    yield put(openFail(error));
  }
}

function* rejectDocument({ payload }) {
  try {
    const response = yield call(rejectService, payload);
    if (response) toast.success("Documento rechazado");
    else toast.error("No se puede rechazar el documento, verifique el estado");
    yield put(rejectSuccess(response));
  } catch (error) {
    toast.error(
      "Error al rechazar el documento. Consulte a los administradores."
    );
    yield put(rejectFail(error));
  }
}

function* fetchEntity({ payload }) {
  try {
    const response = yield call(get, payload);
    yield put(getSuccess(response));
  } catch (error) {
    yield put(getFail(error));
  }
}

function* save(data) {
  try {
    const response = yield call(post, data.payload);
    yield put(saveSuccess(response));
  } catch (error) {
    yield put(saveFail(error));
  }
}

function* saveAssigned(data) {
  try {
    const response = yield call(postSaveAssigned, data.payload);

    if (response) toast.success("El documento ha sido asociado correctamente.");
    else toast.error("El documento no se ha podido asociar");

    yield put(saveAssignedSuccess(response));
  } catch (error) {
    toast.error("El documento no se ha podido asociar");
    yield put(saveAssignedFail(error));
  }
}

 function* saveAttachs({payload}) {

  const {procesar,handleClearAsociarDocumentoProcesar,setShowAssociateDocument} = payload ?? {};
 
  try {
    const response = yield call(postSaveAttachs, procesar);

    if (response){
      toast.success("El documento ha sido guardado correctamente.");
      handleClearAsociarDocumentoProcesar();
      setShowAssociateDocument(false);
    }
    else toast.error("El documento no se ha podido guardar");

    yield put(saveAttachsSuccess(response));
  } catch (error) {
    toast.error("El documento no se ha podido guardar");
    yield put(saveAttachsFail(error));
  }
}

function* saveReactive({payload}) {

   const {objReactive,setShowReactivarViaje} = payload ?? {};
 
  try {
    const response = yield call(postSaveReactive, objReactive);

    if (response){
      toast.success("La reactivación de viaje se ha realizado correctamente.");
       setShowReactivarViaje(false);
    }
    else toast.error("La reactivación de viaje no se ha podido guardar");

    yield put(saveAttachsSuccess(response));
  } catch (error) {
    toast.error("La reactivación de viaje no se ha podido guardar");
    yield put(saveAttachsFail(error));
  }
}

function* updateEntity(data) {
  try {
    const response = yield call(update, data.payload);
    yield put(update(response));
  } catch (error) {
    yield put(updateFail(error));
  }
}
function* download(data) {
  try {
    const response = yield call(exportDocument, data.payload);
    yield call(
      FileSaver.saveAs,
      response,
      `Documents_${new Date().getMilliseconds()}.xlsx`
    );
  } catch (error) {}
}

function* downloadAllDocument(data) {
  try {
    const response = yield call(exportAllDocument, data.payload);
    yield call(
      FileSaver.saveAs,
      response,
      `Documents_${new Date().getMilliseconds()}.xlsx`
    );
  } catch (error) {}
}

function* fetchAllNotAssigned() {
  try {
    const response = yield call(getAllNotAssigned);
    yield put(getAllNotAssignedSuccess(response));
  } catch (error) {
    yield put(getAllNotAssignedFail(error));
  }
}

function* fetchAllPageType() {
  try {
    const response = yield call(getAllPageType);
    yield put(getAllPageTypeSuccess(response));
  } catch (error) {
    yield put(getAllPageTypeFail(error));
  }
}

function* fetchProccess({ payload }) {
  try {
    var msgMinHojas= "El archivo .pdf tiene que tener minimo 3 hojas";
    var MinHojas= 3;
    if (payload.isIrch) {
      msgMinHojas = "El archivo .pdf tiene que tener minimo 1 hoja";
      MinHojas= 1;
    }
    const response = yield call(postProccessService, payload);
    if (response) {
      
      if (response?.length < MinHojas) {
        toast.error(msgMinHojas);
        yield put(
          getAllProccessFail(msgMinHojas)
        );
      } else {
        yield put(getAllProccessSuccess(response));
        toast.success("El documento ha podido agregarse correctamente.");
      }
    } else {
      toast.error("El documento no ha podido agregarse correctamente.");
      yield put(
        getAllProccessFail("El documento no ha podido agregarse correctamente.")
      );
    }
  } catch (error) {
    yield put(getAllProccessFail(error));
    toast.error("El documento no ha podido agregarse correctamente.");
  }
}

function* fetchAllAssigned({ payload }) {
  try {
    const response = yield call(getAllAssigned, payload);
    yield put(getAllAssignedSuccess(response));
  } catch (error) {
    yield put(getAllAssignedFail(error));
  }
}

function* fetchAllAssignedForDocumentId({ payload }) {
  try {
    let { DocumentId, setShowOpenDocument } = payload;
    getAllAssignedForDocumentIds(payload);
    const response = yield call(getAllAssignedForDocumentId, { DocumentId });
    if (response) setShowOpenDocument(true);
    else toast.error("Hubo un problema al abrir el documento .pdf");
    yield put(getAllAllAssignedForDocumentIdSuccess(response));
  } catch (error) {
    toast.error("Hubo un problema al abrir el documento .pdf");
    yield put(getAllAssignedForDocumentIdFail(error));
  }
}


function* fetchRejectionReasonAll({ payload }) {

  try {
    let {  setRechazar } = payload;
    setRechazar(true);
    const response = yield call(getRejectionReasonAll);
    if (response) setRechazar(true);
    else toast.error("Hubo un problema en mostrar los tipos de rechazos");
    yield put(getAllRejectionReasonSuccess(response));
  } catch (error) {
    toast.error("Hubo un problema en mostrar los tipos de rechazos");
    yield put(getAllRejectionReasonFail(error));
  }
}


function* saveApproval({ payload }) {
  try {
    let { assignedId, userId, observation, isAproval, setShowOpenDocument } =
      payload ?? {};

    const response = yield call(postSaveApproval, {
      assignedId,
      userId,
      observation,
      isAproval,
    });

    if (response) {
      toast.success(
        `El documento ha sido ${
          isAproval ? "aprobado" : "rechazado"
        } correctamente.`
      );
      setShowOpenDocument(false);
    } else {
      toast.error(
        `El documento no se ha podido  ${
          isAproval ? "aprobar" : "rechazar"
        } correctamente.`
      );
    }

    yield put(saveAttachsSuccess(response));
  } catch (error) {
    toast.error(
      `El documento no se ha podido  ${
        payload?.isAproval ? "aprobar" : "rechazar"
      } correctamente.`
    );
    yield put(saveAttachsFail(error));
  }
}

function* inboundSaga() {
  yield takeEvery(GET_ALL_STATES, fetchAllStates);
  yield takeEvery(GET, fetchEntity);
  yield takeEvery(GET_BY_DOCUMENT_NUMBER, getByDocument);
  yield takeEvery(GET_ALL, fetchAll);
  yield takeEvery(SAVE, save);
  yield takeEvery(SAVEASSIGNED, saveAssigned);
  yield takeEvery(SAVEATTACHS, saveAttachs);
  yield takeEvery(SAVEAPROVAL, saveApproval);
  yield takeEvery(SAVEREACTIVE, saveReactive);
  yield takeEvery(UPDATE, updateEntity);
  yield takeEvery(DISSASOCIATE, disassociate);
  yield takeEvery(ASSOCIATE, associate);
  yield takeEvery(OPEN, open);
  yield takeEvery(GET_XML_TRANSSMITIONS, xlsTransmissions);
  yield takeEvery(TYPES, getParametrizationList);
  yield takeEvery(UPDATE_TYPES, updateTypes);
  yield takeEvery(REJECT, rejectDocument);
  yield takeEvery(DOWNLOAD, download);
  yield takeEvery(ALLEXPORT, downloadAllDocument);
  yield takeEvery(GET_ALL_ASSIGNED, fetchAllAssigned);
  yield takeEvery(GET_ALL_NOTASSIGNED, fetchAllNotAssigned);
  yield takeEvery(GET_ALL_PAGETYPE, fetchAllPageType);
  yield takeEvery(GET_ALL_REJECTION_REASON, fetchRejectionReasonAll);
  
  yield takeEvery(GET_ALL_PROCCESS, fetchProccess);
  yield takeEvery(
    GET_ALL_ASSIGNED_FOR_DOCUMENTID,
    fetchAllAssignedForDocumentId
  );
}

export default inboundSaga;
